import { EVENTS_NAME } from '@src/consts/common';
import { useEventEmitter } from '@src/hooks/useEventEmitter';
import React, { useCallback, useEffect, useState } from 'react';

import { OnBoardingPopover } from './_Popover/OnBoardingPopover';
import { IOnboardPopoverProps } from './models';

function isUserAlreadySawOnboard(key: string) {
  const val = localStorage.getItem(key);
  return val && val === 'true';
}

/**
 * Отвечает за открытие и закрытие модального окна, сохранение общего состояния и скрытие
 * элементов по спец селекторам hideCssSelectors
 */
export function OnBoardingMini(props: IOnboardPopoverProps) {
  const emitter = useEventEmitter();

  const isNeedOpenOnboardModal = (key: string): boolean => {
    if (isUserAlreadySawOnboard(key)) {
      return false;
    }
    if (!props.urlsToAutoShow) {
      return true;
    }

    const currentUrl = window.location.pathname + window.location.hash;
    for (const urlToAutoShow of props.urlsToAutoShow) {
      if (currentUrl === urlToAutoShow) {
        return true;
      }
    }
    return false;
  };

  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    setIsOpenModal(isNeedOpenOnboardModal(props.id));

    const eventHandler = (detail) => {
      const modalLocalStorageKey = detail.key;
      if (modalLocalStorageKey == props.id) {
        setIsOpenModal(true);
      }
    };

    emitter.on(EVENTS_NAME.OPEN_ON_BOARDING, eventHandler);
    return () => {
      emitter.off(EVENTS_NAME.OPEN_ON_BOARDING, eventHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emitter, props.id]);

  useEffect(() => {
    if (props.hideCssSelectors) {
      for (const selector of props.hideCssSelectors) {
        const els = document.querySelectorAll(selector);
        for (let x = 0; x < els.length; x++) {
          const element = els[x] as HTMLElement;
          if (isOpenModal) {
            element.style.display = 'none';
          } else {
            element.style.display = 'block';
          }
        }
      }
    }
  }, [isOpenModal, props.hideCssSelectors]);

  const handleOnClose = useCallback(() => {
    setIsOpenModal(false);
    localStorage.setItem(props.id, JSON.stringify(true));
  }, [props.id]);

  return (
    <>
      {isOpenModal && (
        <OnBoardingPopover
          open={isOpenModal}
          localStorageKey={props.id}
          onClose={handleOnClose}
          anchor={props.anchor}
          item={props.item}
          popoverProps={props}
        />
      )}
    </>
  );
}
